import {ENVIRONMENT} from '../app/core/config/environments.config';

export const environment = {
    ApiServer: "https://Demo-api.agency.dev.fileandserve.com/",
    // ApiServer: "https://ilsos-api.agency.dev.fileandserve.com/",
    Environment: {
      Env: ENVIRONMENT.DEV,
    },
    MAX_FILE_SIZE: 1_000_000,
    production: false,
    UI_URL: 'https://Demo-api.agency.dev.fileandserve.com/',
    BYPASS_AG_ROLE: false
}
